import { render, staticRenderFns } from "./google-verification.vue?vue&type=template&id=0d12986d&"
import script from "./google-verification.vue?vue&type=script&lang=js&"
export * from "./google-verification.vue?vue&type=script&lang=js&"
import style0 from "./google-verification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports